import React from 'react'
import BurgerIngredient from './BurgerIngredient/BurgerIngredient'

import './Burger.scss'

const Burger = (props) => {
    let ingredients;
    let middleOfBurger = [];

    if (props.ingredients) {
        ingredients = Object.entries(props.ingredients);
        ingredients.forEach((x) => {
          for (let n = 0; n < x[1]; n++) {
            middleOfBurger.push(
              <BurgerIngredient type={x[0]} key={n + x[0] + x[1]} />
            );
          }
        });
    } else {
        ingredients = {}
    }
    
    if (middleOfBurger.length === 0) {
        middleOfBurger = <p>Please start adding some ingredients!</p>
    }
    return (
        <div className="Burger">
            <BurgerIngredient type="bread-top"/>
            {middleOfBurger}
            <BurgerIngredient type="bread-bottom"/>
        </div>
    );
};

export default Burger
